import React from 'react';

import { ModalButtonTrigger } from '@atlassian/entry-points/modal-button-trigger';
import { ModalContextProvider } from '@atlassian/entry-points/modal-context-provider';

import { modalEntryPoint } from '../fixtures/modal-entry-point';
import { RelayWrapper } from '../utils/wrapper';

export default function ModalButtonTriggerExample(): React.JSX.Element {
	return (
		<RelayWrapper>
			<ModalContextProvider>
				<ModalButtonTrigger
					entryPoint={modalEntryPoint}
					modalTitle="Example Modal"
					loadingText="Loading example modal"
					appearance="primary"
					aria-haspopup="dialog"
				>
					Open modal
				</ModalButtonTrigger>
			</ModalContextProvider>
		</RelayWrapper>
	);
}
